import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { SummerSaleTicketsInfoContentWrapper } from './styles'
import { darkMode } from 'styles/theme'
import { SUMMER_SALE_REGULATIONS_LINK } from 'constants/links'
import { Spacing } from 'styles/spacing'
import Link from 'components/shared/Link'
import { useState } from 'react'
import SummerSalePromotionModal from 'components/global/promotions/SummerSale/SummerSalePromotionModal'

type SummerSaleTicketsConfigInfoProps = Spacing

const SummerSaleTicketsConfigInfo = ({
    ...args
}: SummerSaleTicketsConfigInfoProps) => {
    const [isPricingModalOpened, setIsPricingModalOpened] = useState(false)

    const handlePricingModalVisibility = (isOpened: boolean) =>
        setIsPricingModalOpened(isOpened)

    const promotionContent = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.summer_sale.creator_promo_max_discount_guidelines"
                defaultMessage="Skorzystaj z kodu <span>LATO50</span> i <span>kup bilety nawet do 50% taniej</span>! Zniżka naliczy się po wprowadzeniu kodu rabatowego w podsumowaniu zakupu. <break><button>Sprawdź wysokość zniżki</button> na wejście do parku w różnych miesiącach. <link>Regulamin promocji</link></break>"
                values={{
                    break: (chunks: string[]) => (
                        <>
                            <br />
                            {chunks}
                        </>
                    ),
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodySmall"
                                color="primary_500"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                    button: (chunks: string[]) => (
                        <>
                            <Link
                                icon={null}
                                variant="primary"
                                textVariant="bodySmall"
                                isUnderlined
                                onClick={() =>
                                    handlePricingModalVisibility(true)
                                }
                            >
                                {chunks}
                            </Link>
                        </>
                    ),
                    link: (chunks: string[]) => (
                        <Text
                            as="a"
                            href={SUMMER_SALE_REGULATIONS_LINK}
                            target="_blank"
                            variant="bodySmall"
                            isUnderlined
                            color="grayscale_400"
                        >
                            {chunks}
                        </Text>
                    ),
                }}
            />
        </Text>
    )

    return (
        <SummerSaleTicketsInfoContentWrapper isFullWidth {...args}>
            <Info color="info" hasNoBackground hasBorder theme={darkMode}>
                {promotionContent}
            </Info>
            <SummerSalePromotionModal
                isOpened={isPricingModalOpened}
                close={() => handlePricingModalVisibility(false)}
            />
        </SummerSaleTicketsInfoContentWrapper>
    )
}

export default SummerSaleTicketsConfigInfo
